import { SxProps } from '@mui/system'

const drawerStyles: SxProps = {
  '& .MuiDrawer-paper': {
    overflow: 'visible',
  },
}

export const classes = { drawerStyles }
